import { deleteLists as deleteListsRequest } from '@vlabs/api/artemy/client';

import type { DeleteListsFormValues } from '@vlabs/monokit/entities/lists';

import {
  deleteAllCardsFromList,
  detachAllCardsFromList,
  detachAllFacesFromList,
} from './requests';

async function deleteListContent(listId: string): Promise<void> {
  await deleteAllCardsFromList(listId);
}

async function detachListContent(listId: string): Promise<void> {
  await Promise.all([
    detachAllCardsFromList(listId),
    detachAllFacesFromList(listId),
  ]);
}

export async function deleteLists({ listIds, action }: DeleteListsFormValues): Promise<void> {
  await listIds.reduce(async (previousPromise, listId) => {
    await previousPromise;

    if (action === 'delete_content') {
      await deleteListContent(listId);
    } else {
      await detachListContent(listId);
    }

    await deleteListsRequest({ list_ids: [listId] });
  }, Promise.resolve());
}
